<template>
    <div id="index" class="animate-in">
        <!--顶部搜索筛选-->
        <div class="row">
            <div class="col-md-12">
                <div class="box fz-content-box">
                    <div class="box-body fz-box-body">
                    
                        <form class="form-inline searchForm" id="searchForm" action="#" method="GET">
                            <div class="form-group mr15"><span class="fz-menu-name">{{menuName}}</span></div>

                            <div class="form-group">
                                <input value=""
                                    name="_keywords" v-model="searchUser" id="_keywords" class="form-control input-sm fz-input-radiu" placeholder="用户名/客户账号/手机号">
                            </div>
                            <div class="form-group">
                                <a href="#" class="fz-goto-search" @click="toSearch">
                                    <i class="fa fa-search"></i>
                                </a>
                            </div>

                            <div class="form-group">
                                <a href="#"  @click="editAddAccount()" class="btn btn-xs btn-warning ml15 nocss-adddevice fz-color-black" >＋添加</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--数据列表页面-->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="box fz-box">
                        <div class=" table-responsive">
                            <table class="table table-hover fz-table-hover fz-table-bordered datatable" width="100%">
                                <thead>
                                <tr class="fz-gray">
                                    <th>编号</th>
                                    <th>账户ID</th>
                                 
                                    <th>姓名</th>
                                    <!-- <th>性别</th> -->
                                    <th>部门</th>
                                    <th>职务</th>
                                    <th>电话</th>
                                    <th>所属分公司</th>
                                    <th>地址</th>
                                   
                                    <th>编辑</th>
                                    <th>删除</th>
                                </tr>
                                </thead>
                                <tbody>
                                
                                <tr v-for="(item,index) in currentList" :key="item.key" :class="[index===1?'active':'']">
                                    <td>{{item.id}}</td>
                                    <td>{{item.name}}</td>
                                 
                                    <td>{{item.real_name}}</td>
                                    <!-- <td>{{item.sex}}</td> -->
                                    <td>{{item.department}}</td>
                                    <td>{{item.post}}</td>
                                    <td>{{item.tel}}</td>
                                    <td>{{item.company}}</td>
                                    <td>{{item.address}}</td>
                                   
                                    <td class="td-do">
                                        <a href="#"
                                            class="fz-edit2" title="修改" data-toggle="tooltip" @click="editAddAccount(item)">
                                            <i class="fa fa-pencil"></i>
                                        </a>
                                    </td>
                                    <td class="td-do">
                                        <a class="fz-bin2 ajaxButton" @click="deleteUser(item)">
                                            <i class="fa fa-trash"></i>
                                        </a>
                                    </td>
                                </tr>
                                
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <!-- 数据列表底部 -->
                    <div class="fz-box-footer center-block text-center">
                        <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
                    </div>
                </div>
            </div>
        </section>
        
        <!--添加编辑账户 -->
       
            <v-drag v-if="isShow" :title="'编辑账户'"  
             @confirm="saveUser" @cancel="cancel"  :widthData="'500px'" :confirmtext="'保存'" >
                <div class="modal-content">
                 
                    <div class="modal-body fz-modal-body">
                        
                        <form method="post" class="form-horizontal">
    
                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">账户类型:</label>
                                <div class="col-xs-8">
                                   
                                      <select v-model="selectdUser.role"  class="form-control fz-input-select">
                                        <option value="-1">请选择</option>
                                        <option :value="item.value" v-show="item.value > user.role" v-for="(item) in roles" :key="item.id"   >{{ item.text}}</option>
                                                      
                                    </select>
                                </div>
                            </div>
    
                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">账户ID:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off" :disabled="isEdit" v-model="selectdUser.name" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入账户ID">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">密码:</label>
                                <div class="col-xs-8">
                                    <input   v-model="selectdUser.new_password" autocomplete="false" type="password" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入密码">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">姓名:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off"  v-model="selectdUser.real_name" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入姓名">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">部门:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off"  v-model="selectdUser.department" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入部门">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">职务:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off"  v-model="selectdUser.post" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入职务">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">所属分公司:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off"  v-model="selectdUser.company" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入所属分公司">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">联系电话:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off" v-model="selectdUser.tel" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入联系电话">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-xs-3 control-label fz-text-left">地址:</label>
                                <div class="col-xs-8">
                                    <input type="text"  autocomplete="off"  v-model="selectdUser.address" id="move_tuihuonum" class="form-control fz-form-input" placeholder="请输入地址">
                                </div>
                            </div>
    
                        </form>
                        
                    </div>
                
                </div>
            </v-drag>
     
 <transition name="el-fade-in">
            <v-drag v-if="isShowDelete" @confirm="deleteSubmit" @cancel="deleteCancel"  :widthData="'350px'">
                <div class="delete-modal">
                    <div class="delete-content">
                        <img src="../../static/images/what.png" alt="删除">
                        确定要删除此项目？删除后不可恢复
                    </div>
                </div>
            </v-drag>
        </transition>

    </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import 'vue-select/dist/vue-select.css';
import vDrag from "@/components/dragDiv.vue"
import {req} from "../../api/axiosFun"
import vueSelect from "vue-select"
export default {
    name: 'productlist',
    data() {
        return {
            loading: false, //是显示加载
            menuName: "账户管理",
            isEdit:false,role:0,
            listData: [],
            currentList: [],
              isShow: false, //是否显示添加编辑弹出框
            title: "编辑产品",
            hiddenCancel: true,
            searchUser:'',
            user:{},
            selectdUser:{
                role:2,
                name:"",
                real_name:"",
                department:"",
                post:"",
                company:"",
                tel:"",
                address:"",
            },
            roles:[
                {
                    text:'管理员',
                    value:1
                },
                {
                    text:'运营管理',
                    value:2
                },
                {
                    text:'一级账户',
                    value:3
                },
                {
                    text:'二级账户',
                    value:4
                },{
                    text:'三级账户',
                    value:5
                }
            ],
            // 分页参数
            num: 0,
            limit: 2,
             isShowDelete: false, //删除弹框
        }
    },
    components: {
        pagination,
        vDrag,
        "vue-select":  vueSelect
    },
    created() {
        // this.getdata()
    }, 
    mounted() {
        this.getNew(0);
        this.num = this.listData.length;
        this.requestData();
        let user = window.window.sessionStorage.user;
        user = user && JSON.parse(user);
        this.user = user;
    },
    methods: {
        getNew(value) {
            console.log(value);
            this.currentList = this.listData.slice(value, value + this.limit);
            console.log(this.currentList);
        },
        deleteUser(item)
        {
            this.selectdUser = item; 
            this.isShowDelete = true
        },
        toSearch(){
    
            this.requestData('search');
        },
        
         saveUser() {
        //    this.selectdUser.role = this.role.value;
        //    console.log(this.role)/
           const that = this;
            if(this.selectdUser.id) {
                req('PUT', '/user/' + this.selectdUser.id, this.selectdUser)
             .then(res => {
                 if(res.res=='err') {
                     alert('保存失败!')
                 } else {
                     alert('保存成功!');
                      
                 }
                   that.isShow = false;
                   that.requestData();
             })
            } else {
                req('POST', '/user',  this.selectdUser)
             .then(res => {
                 if(res.res=='err') {
                     alert('保存失败!')
                 } else {
                     alert('保存成功!');
                      
                 }that.requestData();
                  that.isShow = false;
             })
            }
             
        },
        deleteSubmit() {
            let _this = this;
           req('DELETE', '/user/' + this.selectdUser.id)
             .then(res => {
                 if(res.res=='err') {
                     alert('删除失败!')
                 } else {
                     alert('删除成功!');
                    
                 }
                   _this.isShowDelete = false;
                   _this.requestData();
             })
        },
        deleteCancel() {
            let _this = this;
            _this.isShowDelete = false;
        },
        editAddAccount(item) {
            if(item) {
                 this.isEdit = true;
                  this.selectdUser = item
            } else {
                this.selectdUser = {}
                this.isEdit = false;
            }
            this.isShow = true;
          
           
        },
        cancel(){
              this.isShow = false;
        },
        cancelModle() {
              $("#editAddAccount_Dialog").modal('hide')
        },
            requestData(s) {
                console.log(s);
                let url = '/user';
                if(s== 'search') {
                    url += '?uid=' + this.searchUser;
                }
           const that = this;
             req('GET',  url)
             .then(res => {
                
                 that.listData = res.data.data;
                 that.currentList = res.data.data;
             })
   
          
        },
    },
}
</script>
<style lang="scss" scoped>
.vue-select1{
    width: 100%;
}
</style>